import React from "react";
import errorImg from "../../images/error-page-img.svg";
import { Box, Typography } from "@mui/material";

const ErrorPage = () => {
  return (
    <Box sx={{display: 'flex', width: '100%'}}>
      <Box sx={{
        display: 'flex',
        width: '100%',
        height: '100vh',
        alignItems: 'center',
        paddingLeft: '20%',
      }}>
        <Box sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          width: '400px',
          lineHeight: '60px',
          height: '100vh',
          zIndex: 5
        }}>
          <Typography
            variant='h1'
            sx={{
              fontSize: '160px',
              fontWeight: 400,
            }}
          >
            404
          </Typography>

          <Typography
            variant='p'
            sx={{
              fontSize: '44px',
              marginTop: 5
            }}
            >
            We're working on it and we'll get it fixed as soon as possible.
          </Typography>
          <Typography
            variant='p'
            sx={{
              fontSize: '44px',
              marginTop: 5
            }}
          >
            You can back or use our Help Center
          </Typography>
        </Box>
        <Box
          component="img"
          sx={{
            position: 'absolute',
            right: 0,
            bottom: 0,
            maxHeight: '80%',
          }}
          alt="Error"
          src={errorImg}
        />
      </Box>
    </Box>
  );
}

export default ErrorPage;
